import type { Ref } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface SignatureLineProps extends HTMLAttributes<HTMLDivElement> {
  placeDate: ReactNode;

  name: ReactNode;
  signatureSrc?: string;

  missingLabel?: ReactNode;
}

export function SignatureLine(
  { ref, placeDate,
    name,
    signatureSrc,
    missingLabel = "noch nicht unterschrieben",
    className,
    ...rest
  }: SignatureLineProps & { ref?: Ref<HTMLDivElement> },
) {
  return (
    <div ref={ref} className={cx('sig-grid', className)} {...rest}>
      <div className="sig-cell">
        <div className="sig-line">{placeDate}</div>
        <span className="sig-caption">Ort, Datum</span>
      </div>
      <div className="sig-cell">
        <div className="sig-line">
          <span>{name}</span>
          {signatureSrc ? (
            <img src={signatureSrc} alt="Unterschrift" />
          ) : (
            <span className="sig-missing">{missingLabel}</span>
          )}
        </div>
        <span className="sig-caption">Name in Druckbuchstaben und Unterschrift</span>
      </div>
    </div>
  );
}
